// UID: NPO-BDGT-FILE
// https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import PriorYearBudgetRuleset from '../../business/ruleset/PriorYearBudgetRuleset';

const { priorYearBudgets } = loanFormModel.formField.hoaDocuments;

export class PriorYearBudgetsValidation implements ValidationSchema {
  public name = priorYearBudgets.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = PriorYearBudgetRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required)
      return FileNameValidationSchema(priorYearBudgets.name, true).required(
        'This document is required'
      );
    return FileNameValidationSchema(priorYearBudgets.name, false).notRequired();
  }
}
export default new Validation(new PriorYearBudgetsValidation());
